import React, { useState, useRef, useCallback, useEffect } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Button from '../../../../components/Buttons/Button';
import SearchField from '../../../../components/Search/SearchField';

const CollapsibleSearch = ({ placeholder = 'Search by report name', disabled, onChange }) => {
  const inputRef = useRef();
  const searchFieldRef = useRef();

  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    if (searchFieldRef.current && searchFieldRef.current.getSearchQuery()) {
      searchFieldRef.current.clearSearch(false);
    }

    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus({ preventScroll: true });
    }
  }, [isOpen]);

  return (
    <div className={cx('collapsible-search', { 'collapsible-search--open': isOpen })}>
      <Button
        shape="square"
        variant="secondary"
        disabled={disabled}
        className="collapsible-search__trigger"
        onClick={handleOpen}
      >
        <i className="hicon-search-short" />
      </Button>
      <div className="collapsible-search__field-wrapper">
        <SearchField
          ref={inputRef}
          size="sm"
          placeholder={placeholder}
          disabled={disabled}
          instanceRef={searchFieldRef}
          className="collapsible-search__field"
          onChange={onChange}
        />
        <div
          className="collapsible-search__close-btn"
          aria-label="Close search"
          onClick={handleClose}
        >
          <i className="hicon-close" />
        </div>
      </div>
    </div>
  );
};

CollapsibleSearch.propTypes = {
  onChange: T.func.isRequired,
  placeholder: T.string,
  disabled: T.bool,
};

export default CollapsibleSearch;
